{
  "name": "randy",
  "version": "2.0.0",
  "license": "MIT",
  "scripts": {
    "start": "nx serve",
    "build": "nx build",
    "test": "nx test",
    "nx": "nx",
    "postinstall": "ngcc --properties es2015 browser module main",
    "source-map-explorer": "source-map-explorer dist/apps/dash/randy/nl/**/*.js",
    "analyze-randy": "webpack-bundle-analyzer dist/apps/dash/randy/nl/stats.json",
    "precommit": "nx affected --target version --uncommitted ---verbose",
    "prepare": "husky install",
    "build run-local": "cd tools/scripts/ci-cd/run-local && npx tsc -p tsconfig.json",
    "build generate-gitlab-ci": "cd tools/scripts/ci-cd/generate-gitlab-ci && npx tsc -p tsconfig.json",
    "local deploy": "npm run 'build generate-gitlab-ci' && npm run 'build run-local' && node tools/scripts/ci-cd/run-local/index.js",
    "agent:routes": "ts-node --project tools/tsconfig.tools.json tools/scripts/agent/search-routes.ts",
    "agent:routes:test": "node --test tools/scripts/agent/search-routes.test.js"
  },
  "private": true,
  "dependencies": {
    "@acrodata/code-editor": "^0.5.1",
    "@angular/animations": "19.2.8",
    "@angular/cdk": "19.2.9",
    "@angular/common": "19.2.8",
    "@angular/compiler": "19.2.8",
    "@angular/core": "19.2.8",
    "@angular/elements": "19",
    "@angular/fire": "7.2.0",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "19.2.8",
    "@angular/localize": "19.2.8",
    "@angular/material": "19.2.9",
    "@angular/platform-browser": "19.2.8",
    "@angular/platform-browser-dynamic": "19.2.8",
    "@angular/router": "19.2.8",
    "@animetosho/parpar": "^0.4.3",
    "@aws-sdk/client-auto-scaling": "^3.993.0",
    "@aws-sdk/client-batch": "^3.993.0",
    "@aws-sdk/client-cloudfront": "^3.993.0",
    "@aws-sdk/client-cloudwatch": "^3.993.0",
    "@aws-sdk/client-cloudwatch-logs": "^3.993.0",
    "@aws-sdk/client-cognito-identity": "^3.993.0",
    "@aws-sdk/client-cognito-identity-provider": "^3.993.0",
    "@aws-sdk/client-dynamodb": "^3.993.0",
    "@aws-sdk/client-ec2": "^3.993.0",
    "@aws-sdk/client-ecr": "^3.993.0",
    "@aws-sdk/client-ecs": "^3.993.0",
    "@aws-sdk/client-elastic-load-balancing-v2": "^3.993.0",
    "@aws-sdk/client-eventbridge": "^3.993.0",
    "@aws-sdk/client-route-53": "^3.993.0",
    "@aws-sdk/client-s3": "^3.993.0",
    "@aws-sdk/client-ses": "^3.993.0",
    "@aws-sdk/client-sqs": "^3.993.0",
    "@aws-sdk/client-ssm": "^3.993.0",
    "@aws-sdk/lib-dynamodb": "^3.993.0",
    "@aws-sdk/lib-storage": "^3.993.0",
    "@aws-sdk/protocol-http": "^3.374.0",
    "@aws-sdk/s3-request-presigner": "^3.993.0",
    "@aws-sdk/signature-v4": "^3.374.0",
    "@aws-sdk/signature-v4-crt": "^3.993.0",
    "@aws-sdk/util-arn-parser": "^3.972.2",
    "@clickhouse/client": "1.2.0",
    "@codemirror/lang-liquid": "6.3.1",
    "@codemirror/lang-python": "^6.2.1",
    "@codemirror/lint": "6.9.3",
    "@codemirror/state": "^6.5.2",
    "@codemirror/view": "^6.38.1",
    "@duckdb/node-api": "^1.4.0-r.1",
    "@fortawesome/fontawesome-svg-core": "6.1.1",
    "@fortawesome/free-solid-svg-icons": "6.1.1",
    "@lambda-middleware/compose": "^1.2.0",
    "@lambda-middleware/utils": "^1.0.4",
    "@langchain/core": "1.1.38",
    "@langchain/langgraph": "^1.2.6",
    "@langchain/mcp-adapters": "^0.4.0",
    "@langchain/openai": "1.4.1",
    "@langfuse/core": "^5.0.2",
    "@langfuse/langchain": "^5.0.2",
    "@langfuse/otel": "^5.0.2",
    "@langfuse/tracing": "^5.0.2",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "@neo4j-cypher/codemirror": "^1.0.3",
    "@neo4j-cypher/editor-support": "^1.0.2",
    "@ng-matero/extensions": "18.5.0",
    "@ngrx/component-store": "18.1.1",
    "@ngrx/effects": "19.1.0",
    "@ngrx/entity": "19.1.0",
    "@ngrx/operators": "19.1.0",
    "@ngrx/signals": "19.1.0",
    "@ngrx/store": "19.1.0",
    "@ngrx/store-devtools": "19.1.0",
    "@nuxtjs/leaflet": "1.2.6",
    "@nx/webpack": "20.8.1",
    "@opentelemetry/api": "^1.9.1",
    "@opentelemetry/sdk-node": "^0.214.0",
    "@pinia/nuxt": "^0.10.1",
    "@sentry/angular": "10.48.0",
    "@sentry/serverless": "7.114.0",
    "@sentry/tracing": "7.114.0",
    "@sentry/webpack-plugin": "^2.20.1",
    "@swc/helpers": "0.5.11",
    "@tokenizer/s3": "^0.2.0",
    "@types/archiver": "^6.0.2",
    "@types/cytoscape": "^3.21.9",
    "@types/ejs": "^3.1.1",
    "@types/express": "5.0.6",
    "@types/marked": "4.3.0",
    "@types/nunjucks": "^3.2.1",
    "@types/rbush": "^4.0.0",
    "@types/sharp": "^0.30.0",
    "@types/ssh2-sftp-client": "^9.0.6",
    "@types/yaml": "^1.9.7",
    "@vue/web-component-wrapper": "^1.3.0",
    "@zilliz/milvus2-sdk-node": "^2.2.10",
    "altcha": "^1.3.0",
    "altcha-lib": "^1.2.0",
    "amazon-cognito-identity-js": "5.2.8",
    "angular-oauth2-oidc": "17.0.2",
    "angular-split": "^19.0.0",
    "apache-arrow": "^21.0.0",
    "archiver": "^6.0.1",
    "aws-crt": "^1.10.5",
    "aws-jwt-verify": "^2.1.0",
    "babel-eslint": "^10.1.0",
    "basic-ftp": "^5.1.0",
    "bloom-filters": "^3.0.0",
    "buffer": "^6.0.3",
    "chart.js": "4.5.1",
    "chartjs-plugin-datalabels": "2.2.0",
    "chatgpt": "^5.2.5",
    "class-transformer": "^0.5.1",
    "class-transformer-validator": "^0.9.1",
    "class-validator": "^0.13.2",
    "clientjs": "^0.2.0",
    "core-js": "^3.6.5",
    "cropperjs": "1.5.12",
    "crypto-random-string": "^4.0.0",
    "csv-parse": "^5.0.4",
    "csv-parser": "^3.0.0",
    "csv-stringify": "^6.5.0",
    "cytoscape": "^3.33.0",
    "d3-shape": "^3.2.0",
    "dashjs": "^4.7.4",
    "date-fns": "^2.29.3",
    "date-fns-tz": "^1.3.7",
    "decimal.js": "^10.4.3",
    "edtf": "https://github.com/bram-sofco/edtf.js.git",
    "ejs": "^3.1.8",
    "elkjs": "0.8.2",
    "email-validator": "^2.0.4",
    "eventsource-parser": "^3.0.8",
    "express": "5.2.1",
    "file-saver": "2.0.5",
    "file-type": "^17.1.1",
    "firebase": "9.6.5",
    "flag-icons": "^6.6.6",
    "fluent-ffmpeg": "2.1.2",
    "fuse.js": "^7.1.0",
    "generic-pool": "^3.9.0",
    "gpt3-tokenizer": "^1.1.5",
    "graphology": "^0.26.0",
    "graphology-layout": "^0.6.1",
    "graphology-layout-forceatlas2": "^0.10.1",
    "graphology-types": "^0.24.8",
    "graphql": "15.8.0",
    "graphql-request": "3.7.0",
    "hashids": "^2.2.10",
    "http-errors": "^2.0.0",
    "http-server": "^0.12.3",
    "iiif-processor": "5.2.0",
    "interactjs": "^1.10.17",
    "ioredis": "^5.3.2",
    "json-server": "0.16.3",
    "jsonwebtoken": "^8.5.1",
    "jwk-to-pem": "^2.0.5",
    "kysely": "^0.28.7",
    "lambda-stream": "^0.5.0",
    "langchain": "^1.2.39",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "1.5.3",
    "liquidjs": "^10.24.0",
    "marked": "4.3.0",
    "masonry-layout": "^4.2.2",
    "mitt": "^2.1.0",
    "monaco-editor": "^0.52.2",
    "ng-extract-i18n-merge": "^2.5.0",
    "ng2-pdfjs-viewer": "^19.0.0",
    "ngx-dropzone": "3.1.0",
    "ngx-joyride": "2.5.0",
    "ngx-markdown": "19.1.1",
    "ngx-mat-select-search": "8.0.1",
    "ngx-monaco-editor-v2": "^20.0.0",
    "ngx-quill": "18.0.0",
    "ngx-skeleton-loader": "^11.3.0",
    "ngx-spinner": "18.0.0",
    "node-expat": "^2.4.0",
    "node-fetch": "3.2.10",
    "nuxt": "3.16.0",
    "object-hash": "^3.0.0",
    "openai": "4.82.0",
    "pdfjs-dist": "^5.3.31",
    "pinia": "^3.0.1",
    "pyodide": "^0.29.0",
    "qr-code-styling": "^1.6.0-rc.1",
    "quill": "1.3.7",
    "ramda": "^0.27.2",
    "raw-loader": "^4.0.2",
    "rbush": "^4.0.1",
    "react": "18.3.1",
    "react-dom": "18.3.1",
    "reflect-metadata": "^0.1.13",
    "regenerator-runtime": "0.13.7",
    "rete": "2.0.6",
    "rete-angular-plugin": "^2.5.0",
    "rete-area-plugin": "2.1.3",
    "rete-auto-arrange-plugin": "2.0.2",
    "rete-connection-path-plugin": "^2.0.4",
    "rete-connection-plugin": "2.0.5",
    "rete-context-menu-plugin": "2.0.6",
    "rete-engine": "2.1.1",
    "rete-history-plugin": "2.1.1",
    "rete-minimap-plugin": "^2.0.3",
    "rete-render-utils": "^2.0.3",
    "rxfire": "6.0.3",
    "rxjs": "7.5.2",
    "sharp": "0.34.1",
    "sigma": "^3.0.2",
    "source-map-explorer": "^2.5.3",
    "spark-md5": "3.0.2",
    "speak-tts": "https://github.com/ZachteBank/speak-tts.git",
    "ssh2-sftp-client": "^12.0.1",
    "tar-stream": "^3.1.7",
    "telegraf": "^4.12.2",
    "three": "^0.184.0",
    "tslib": "^2.3.0",
    "vue": "3.5.13",
    "vue-pdf-embed": "^2.1.2",
    "vue-router": "4.5.0",
    "vuex": "^3.6.2",
    "web-worker": "1.2.0",
    "webfontloader": "^1.6.28",
    "webpack": "5.98.0",
    "xlsx": "^0.18.5",
    "yaml": "^2.2.1",
    "yauzl": "^3.2.0",
    "zod": "4.3.6",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/architect": "0.1902.9",
    "@angular-devkit/build-angular": "19.2.9",
    "@angular-devkit/schematics": "19.2.9",
    "@angular/compiler-cli": "19.2.8",
    "@angular/language-service": "19.2.8",
    "@aws-sdk/client-lambda": "^3.58.0",
    "@babel/core": "^7.21.8",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-decorators": "^7.21.0",
    "@babel/plugin-proposal-private-property-in-object": "7.21.11",
    "@babel/plugin-transform-modules-commonjs": "^7.21.5",
    "@babel/preset-env": "^7.21.5",
    "@babel/preset-react": "^7.14.5",
    "@babel/preset-typescript": "^7.21.5",
    "@commitlint/cli": "^17.0.0",
    "@commitlint/config-conventional": "^17.1.0",
    "@faker-js/faker": "^10.0.0",
    "@gyeonghokim/bruno-to-openapi": "^1.2.0",
    "@iconify-json/fa-solid": "^1.2.1",
    "@jscutlery/semver": "^2.27.1",
    "@ngrx/component-store": "19.1.0",
    "@nuxt/icon": "^1.10.3",
    "@nuxtjs/eslint-config-typescript": "12.1.0",
    "@nuxtjs/eslint-module": "3.1.0",
    "@nx-aws-plugin/nx-aws-cache": "3.2.1",
    "@nx-dotnet/core": "2.2.0",
    "@nx-tools/nx-container": "6.0.1",
    "@nx/angular": "20.8.1",
    "@nx/cypress": "20.8.1",
    "@nx/devkit": "20.8.1",
    "@nx/eslint": "20.8.1",
    "@nx/eslint-plugin": "20.8.1",
    "@nx/jest": "20.8.1",
    "@nx/js": "20.8.1",
    "@nx/node": "20.8.1",
    "@nx/nuxt": "20.8.1",
    "@nx/plugin": "20.8.1",
    "@nx/react": "20.8.1",
    "@nx/web": "20.8.1",
    "@nx/workspace": "20.8.1",
    "@schematics/angular": "19.2.9",
    "@sentry/cli": "^2.15.2",
    "@shelf/jest-dynamodb": "^2.2.3",
    "@swc-node/register": "^1.11.1",
    "@swc/cli": "^0.7.10",
    "@swc/core": "^1.15.10",
    "@testing-library/react": "16.1.0",
    "@types/aws-lambda": "^8.10.89",
    "@types/fluent-ffmpeg": "^2.1.24",
    "@types/glob": "^7.2.0",
    "@types/http-errors": "^1.8.1",
    "@types/jasmine": "3.10.5",
    "@types/jasminewd2": "2.0.10",
    "@types/jest": "29.5.14",
    "@types/jsonwebtoken": "^8.5.8",
    "@types/jwk-to-pem": "^2.0.1",
    "@types/leaflet": "^1.9.21",
    "@types/leaflet.markercluster": "1.5.6",
    "@types/node": "^18.16.9",
    "@types/node-fetch": "^2.6.2",
    "@types/object-hash": "^3.0.6",
    "@types/puppeteer": "^7.0.4",
    "@types/ramda": "^0.27.63",
    "@types/react": "18.3.1",
    "@types/react-dom": "18.3.0",
    "@types/tar-stream": "^3",
    "@types/three": "^0.184.1",
    "@typescript-eslint/eslint-plugin": "7.18.0",
    "@typescript-eslint/parser": "7.18.0",
    "@vue/cli-plugin-babel": "5.0.8",
    "@vue/cli-plugin-eslint": "5.0.8",
    "@vue/cli-plugin-typescript": "5.0.8",
    "@vue/cli-plugin-vuex": "5.0.8",
    "@vue/cli-service": "5.0.8",
    "@vue/eslint-config-prettier": "6.0.0",
    "@vue/eslint-config-typescript": "^5.0.2",
    "@vue/test-utils": "^1.0.3",
    "@vue/vue2-jest": "^27.0.0-alpha.1",
    "adm-zip": "^0.5.9",
    "aws-lambda-mock-context": "^3.2.1",
    "aws-sdk-mock": "^5.5.1",
    "babel-core": "^7.0.0-bridge.0",
    "babel-eslint": "^10.1.0",
    "babel-jest": "29.7.0",
    "copy-webpack-plugin": "^11.0.0",
    "css-loader": "4.3.0",
    "cypress": "14.3.2",
    "dotenv": "^16.4.5",
    "eslint": "8.57.0",
    "eslint-config-prettier": "10.1.2",
    "eslint-plugin-cypress": "2.15.2",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "^39.2.5",
    "eslint-plugin-jsx-a11y": "6.10.1",
    "eslint-plugin-nuxt": "^3.2.0",
    "eslint-plugin-prefer-arrow": "latest",
    "eslint-plugin-prettier": "4.0.0",
    "eslint-plugin-vue": "^7.16.0",
    "firebase-tools": "9.23.3",
    "fuzzy": "0.1.3",
    "glob": "^7.2.0",
    "hcl2-parser": "^1.0.3",
    "husky": "^8.0.3",
    "inquirer": "6.5.2",
    "inquirer-autocomplete-prompt": "1.4.0",
    "jasmine-core": "4.0.0",
    "jasmine-spec-reporter": "5.0.2",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-preset-angular": "14.4.2",
    "jest-serializer-vue": "^2.0.2",
    "jest-transform-stub": "^2.0.0",
    "jsonc-eslint-parser": "^2.1.0",
    "jsonc-parser": "3.0.0",
    "karma": "6.3.17",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "4.0.1",
    "karma-jasmine-html-reporter": "1.7.0",
    "merge": "^2.1.1",
    "mime-types": "^2.1.35",
    "ng2-charts-schematics": "0.1.7",
    "node-loader": "^2.0.0",
    "nunjucks": "^3.2.3",
    "open": "7.4.2",
    "postcss-loader": "3.0.0",
    "prettier": "^2.6.2",
    "protractor": "7.0.0",
    "puppeteer": "24.1.1",
    "sass-loader": "16.0.5",
    "shx": "^0.4.0",
    "testcontainers": "^11.7.2",
    "ts-jest": "29.1.5",
    "ts-loader": "^8.3.0",
    "ts-node": "10.9.1",
    "typescript": "5.8.3",
    "webpack-bundle-analyzer": "^4.6.1",
    "webpack-node-externals": "^3.0.0"
  },
  "packageManager": "yarn@4.3.1"
}
